import util from './util'

function isDataSet(dataset) {
  return dataset.startsWith('data-')
}

function getAttrs(node) {
  if (!node) return {}
  const attributes = node.attributes
  const dataset = node.dataset
  const tagName = node.tagName
  const opt = {}
  if (node.nodeType === 1) opt.textContent = node.textContent
  Array.from(attributes).forEach(({ name, value }) => {
    if (!isDataSet(name)) {
      name = toHump(name)
      opt[name] = value
    }
  })
  Object.assign(opt, dataset, { tagName })
  return opt
}

function toHump(name) {
  return name.replace(/-(\w)/g, function (all, letter) {
    return letter.toUpperCase()
  })
}

function toLine(name) {
  return name.replace(/([A-Z])/g, '-$1').toLowerCase()
}

const compile = {
  // option => str
  attrString(option) {
    return Object.entries(option)
      .map((item) => {
        const [a, b] = item
        const name = toLine(a)
        return `${name}="${b}"`
      })
      .join(' ')
  },
  item(temp, codes) {
    return Array.from(temp).map((template) => {
      const option = this.getOption(template, codes)
      const { type, name } = option
      const item = type && $.type(util[type]) === 'function' && util[type](option)
      return { template, option, type, item, name }
    })
  },
  getOption(template, codes) {
    const option = getAttrs(template)
    const { code } = option
    if (code) {
      option.data = this.dataCode(option.code, codes)
      delete option.code
    }
    return option
  },
  getItem(opt) {
    const { type, name } = opt
    const item = type && $.type(util[type]) === 'function' && util[type](opt)
    return { opt, type, item, name }
  },
  read(el) {
    let temp
    const tem = el.find('template')
    if (tem.length > 0) {
      temp = tem[0].content.querySelectorAll('*')
    } else if (!temp) {
      temp = el.children()
      if (temp.length === 0) temp = null
      temp.detach()
    }
    return temp
  },
  unit(opt) {
    const { type = 'text', mod, tagName } = opt
    if (tagName === 'BUTTON') return util.button(opt)
    return util[type](opt, mod)
  },
  input(node, marks) {
    const opt = getAttrs(node)
    Object.assign(opt, marks)
    const obj = this.unit(opt)
    const { outer, inner } = util.formItem(opt)
    Object.assign(obj, { outer, inner })
    const { unit } = obj
    if (inner) {
      inner.append(unit)
    } else {
      obj.outer = obj.inner = obj.unit
    }
    return obj
  },
  button(node) {
    const opt = getAttrs(node)
    return this.unit(opt)
  },
  section(node) {
    const opt = getAttrs(node)
    return util.section(opt)
  },
  cell(temp) {
    const fields = []
    const navs = []
    const ins = []
    Array.from(temp).map((el) => {
      const opt = getAttrs(el)
      if (el.tagName === 'DIV') {
        fields.push(opt)
      } else if (el.tagName === 'NAV') {
        navs.push(opt)
      } else {
        ins.push(opt)
      }
    })
    return { fields, navs, ins }
  },
  nav(el) {
    const $el = $(el)
  },
  dataCode(code, codes) {
    const data = []
    if (!codes || codes.length === 0) return data
    codes[code.trim().toLowerCase()].map((x) => {
      x.id = x.f_code
      x.text = x.f_name
      x.pid = '0'
      if (x.children && x.children.length > 0) {
        this.formatCode(data, x.children, x.id)
        x.dis = true
      }
      data.push(x)
    })
    return data
  },
  formatCode(data, list, pid) {
    list.map((x) => {
      x.id = x.f_code
      x.text = x.f_name
      x.pid = pid
      if (x.children && x.children.length > 0) {
        this._formatCode(data, x.children)
        x.dis = true
      }
      data.push(x)
    })
  }
}

export default compile
